"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const Spinner = styled_components_1.default.div `
  position: relative;

  width: 22px;
  height: 22px;
  margin: auto;

  &::after {
    position: absolute;

    box-sizing: border-box;
    width: 100%;
    height: 100%;

    border-style: solid;
    border-width: 3px;
    border-top-color: rgba(92, 101, 108, 0.2);
    border-right-color: rgba(92, 101, 108, 0.2);
    border-bottom-color: rgba(92, 101, 108, 0.2);
    border-left-color: #5c656c;
    border-radius: 50%;

    animation: rotate 0.5s infinite linear;

    content: '';
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
exports.default = Spinner;
